var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, DropdownDivider, DropdownHeader, Form, Grid, Icon, Input, Popup, Select, Table } from "semantic-ui-react";
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { getWithAuthn } from "../../RequestHelpers";
import { isPredictedTarget, targetHasMIValidatedEntry } from "../KitToFormStateUtilityFunctions";
import { PriceDisplay } from "../rna-fish/EditKitForm";
import { accessionSearchLink } from "../rna-fish/KitDisplay";
import { cleanUpRnaSeq, uniqueBy } from "../rna-fish/ProbeSetForm";
import { debounce } from "./EditKitForm";
var ProbeSetForm = /** @class */ (function (_super) {
    __extends(ProbeSetForm, _super);
    function ProbeSetForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debounceSearchQueryChange = debounce(function (event, data) {
            _this.onSearchQueryChange(event, data);
        }, 500);
        _this.effectiveOrganisms = function () {
            var organisms = _this.props.catalog.probeSet.catalog.organisms.map(function (o) {
                var scientificName = o.scientificName.length > 0 && o.scientificName !== o.name ? "(" + o.scientificName + ")" : '';
                return {
                    text: (o.name + " " + scientificName).trim(),
                    content: (o.name + " " + (o.scientificName.length > 0 && o.scientificName !== o.name ? '(' + o.scientificName + ')' : '')).trim(),
                    value: o.id
                };
            });
            if (_this.props.probeSetState.organism.id === -1 && _this.props.probeSetState.organism.name.trim() !== "") {
                organisms = organisms.concat([
                    {
                        text: _this.props.probeSetState.organism.name,
                        content: _this.props.probeSetState.organism.name,
                        value: _this.props.probeSetState.organism.id
                    }
                ]);
            }
            return uniqueBy(organisms, function (o) { return o.value; });
        };
        _this.onAddCustomOrganism = function (_, data) {
            var str = data.value;
            _this.props.onProbeSetChange({
                organism: new RnaCishEditableOrganism(str, "", -1)
            }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.onAddCustomTarget = function (_, data) {
            var ct = data.value;
            _this.props.onProbeSetChange({
                target: new RnaCishEditableTarget(ct, "", "", "", _this.props.catalog.probeSet.custom.probeSetSizes[0], -1, false, false, undefined),
            }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.onSearchChange = function (event, data) {
            if (_this.props.probeSetState.organism.id !== -1 && data.searchQuery.length !== 0) {
                // Call the debounced function
                _this.debounceSearchQueryChange(event, data);
            }
        };
        _this.effectiveTargets = function () {
            var exactMatchFamilies = _this.props.probeSetState.targets.filter(function (psf) {
                return _this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.props.probeSetState.searchQuery);
            });
            var synonymFamilies = _this.props.probeSetState.targets.filter(function (psf) {
                return _this.searchQueryIsSynonymForProbeSetFamily(psf, _this.props.probeSetState.searchQuery);
            });
            var otherProbeSetFamilies = _this.props.probeSetState.targets.filter(function (psf) {
                return !_this.searchQueryIsSynonymForProbeSetFamily(psf, _this.props.probeSetState.searchQuery) &&
                    !_this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.props.probeSetState.searchQuery);
            });
            var options = [];
            options = options.concat((exactMatchFamilies.length > 0 || synonymFamilies.length > 0) ? [
                React.createElement(DropdownHeader, { key: 'recommended-header', content: 'Recommended' }),
                React.createElement(DropdownDivider, { key: 'recommended-divider' })
            ] : []).concat(exactMatchFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat(synonymFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : f.geneSymbol;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat((otherProbeSetFamilies.length !== 0 && _this.props.probeSetState.searchQuery !== '') ? [
                React.createElement(DropdownHeader, { key: 'other-header', content: "Other Results for " + _this.props.probeSetState.searchQuery }),
                React.createElement(DropdownDivider, { key: 'other-divider' })
            ]
                : []).concat(otherProbeSetFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat((_this.props.probeSetState.target.id === -1 && _this.props.probeSetState.target.name.trim() !== "") ? [
                {
                    text: _this.props.probeSetState.target.name,
                    value: -1
                }
            ] : []);
            return options;
        };
        _this.noOrganismSelected = function () {
            var organism = _this.props.probeSetState.organism;
            return organism.id === -1 && organism.name.trim() === "";
        };
        _this.noTargetSelected = function () {
            var target = _this.props.probeSetState.target;
            return target.id === -1 && target.name.trim() === "";
        };
        _this.searchQueryIsSynonymForProbeSetFamily = function (f, searchQuery) {
            return !!f.synonyms.find(function (s) { return s.toLowerCase() === searchQuery; });
        };
        _this.searchQueryIsExactMatchToProbeSetFamily = function (f, searchQuery) {
            return f.geneSymbol.toLowerCase() === searchQuery.toLowerCase();
        };
        _this.amplifierOptions = function () {
            return _this.props.catalog.proAmplifier.hcrAmplifiers.map(function (a) {
                return {
                    text: a.id,
                    value: a.id
                };
            });
        };
        _this.customTargetProbeSetSizeInput = function () {
            var inputNode = React.createElement(Input, { name: 'probe-set-size', onChange: _this.onCustomProbeSetFlexibleSizeChange, type: 'number', value: _this.props.probeSetState.target.probeSetSize });
            return React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeSet/customParams/probeSetSize', errors: _this.props.errors, labelContent: "# of binding sites", labelFor: 'probe-set-size' }, inputNode);
        };
        _this.onCustomProbeSetFlexibleSizeChange = function (_, data) {
            var v = data.value;
            var num = parseInt(v, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setCustomTargetState(function (t) { return t.withProbeSetSize(num); }, _this.props.onUserSelection);
        };
        _this.onOrganismChange = function (_, data) {
            var organismId = data.value;
            var selectedOrganism = _this.props.catalog.probeSet.catalog.organisms
                .find(function (s) { return s.id === organismId; });
            _this.props.onProbeSetChange({
                searchQuery: '',
                organism: selectedOrganism ? RnaCishEditableOrganism.fromLibOrg(selectedOrganism) : RnaCishEditableOrganism.default(),
                target: RnaCishEditableTarget.default(_this.props.catalog.probeSet.custom.probeSetSizes[0]),
                targets: []
            }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.onTargetChange = function (_, data) {
            var value = data.value;
            if (typeof data.value === "number") {
                getWithAuthn("/admin/rna/search/probeSetFamilyId/" + encodeURIComponent(value))
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (jsonFamily) {
                    if (jsonFamily !== undefined && jsonFamily.psf != null) {
                        _this.props.onProbeSetChange(function () {
                            var _a;
                            var target = jsonFamily.psf;
                            var accession = (_a = target.defaultVariant.accession) === null || _a === void 0 ? void 0 : _a.transcriptAccession;
                            var variantId = jsonFamily.variantId;
                            return {
                                searchLoading: false,
                                target: new RnaCishEditableTarget(target.geneSymbol, target.description, accession ? accession : "", target.defaultVariant.targetMrnaSeq, target.defaultVariant.probeSetSize, target.id, targetHasMIValidatedEntry(target), isPredictedTarget(target), variantId)
                            };
                        }, _this.props.channel, _this.props.onUserSelection);
                    }
                    else {
                        _this.props.onProbeSetChange(function () {
                            return {
                                searchLoading: false,
                                target: RnaCishEditableTarget.default(-1),
                                searchQuery: ""
                            };
                        }, _this.props.channel, _this.props.onUserSelection);
                    }
                });
            }
            else {
                _this.props.onProbeSetChange(function () {
                    return {
                        searchLoading: false,
                        variant: undefined,
                        target: RnaCishEditableTarget.default(-1),
                        searchQuery: "",
                        targets: []
                    };
                }, _this.props.channel, _this.props.onUserSelection);
            }
        };
        _this.onAccessionChange = function (event) {
            var str = event.currentTarget.value;
            _this.setCustomTargetState(function (t) {
                return t.withAccession(str);
            });
        };
        _this.onRnaSeqChange = function (event) {
            var s = event.currentTarget.value;
            _this.setCustomTargetState(function (t) {
                return t.withRna(cleanUpRnaSeq(s));
            });
        };
        _this.onAmplifierChange = function (_, data) {
            var val = data.value;
            var newHcrAmplifier = _this.props.catalog.proAmplifier.hcrAmplifiers.find(function (a) { return a.id === val; });
            _this.props.onProbeSetChange({
                hcrAmplifier: newHcrAmplifier
            }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.onPmolScaleChange = function (_, data) {
            var pmolScale = _this.parseNonNegativeNumber(data.value);
            if (pmolScale === undefined) {
                return;
            }
            _this.props.onProbeSetChange({
                probeScalePmol: pmolScale
            }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.onProbeHybridizationAScaleChange = function (_, data) {
            var probeHybridizationAScale = _this.parseNonNegativeNumber(data.value);
            if (probeHybridizationAScale === undefined) {
                return;
            }
            _this.props.onProbeSetChange({
                probeHybridizationAScale: probeHybridizationAScale
            }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.onProbeHybridizationBScaleChange = function (_, data) {
            var probeHybridizationBScale = _this.parseNonNegativeNumber(data.value);
            if (probeHybridizationBScale === undefined) {
                return;
            }
            _this.props.onProbeSetChange({
                probeHybridizationBScale: probeHybridizationBScale
            }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.onProbeScaleUlChange = function (_, data) {
            var probeScaleUl = _this.parseNonNegativeNumber(data.value);
            if (probeScaleUl === undefined) {
                return;
            }
            _this.props.onProbeSetChange({
                probeScaleUl: probeScaleUl
            }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onProbeSetChange(function (oldState) {
                return {
                    customPrice: newStateFn(oldState.customPrice)
                };
            }, _this.props.channel, callback);
        };
        _this.setCustomTargetState = function (t, callback) {
            _this.props.onProbeSetChange({
                target: t(_this.props.probeSetState.target)
            }, _this.props.channel, callback);
        };
        _this.onSearchQueryChange = function (_, data) {
            var path = "";
            if (data.searchQuery.length === 0) {
                _this.props.onProbeSetChange(function () {
                    return {
                        targets: [],
                        searchQuery: "",
                        target: data.searchQuery.length === 0
                            ? RnaCishEditableTarget.default(-1)
                            : _this.props.probeSetState.target
                    };
                }, _this.props.channel);
                return;
            }
            path = "/admin/rna/search/id/" +
                (encodeURIComponent(_this.props.probeSetState.organism.id) + "/targetGene/") +
                ("" + encodeURIComponent(data.searchQuery));
            getWithAuthn(path)
                .then(function (resp) {
                if (resp.status === 200) {
                    return resp.json();
                }
                else {
                    return undefined;
                }
            })
                .then(function (resp) {
                _this.props.onProbeSetChange(function () {
                    if (resp !== undefined) {
                        return {
                            searchLoading: false,
                            searchQuery: data.searchQuery,
                            targets: resp.probeSetFamilyResults
                        };
                    }
                    else {
                        return {
                            searchLoading: false,
                            searchQuery: data.searchQuery
                        };
                    }
                }, _this.props.channel, _this.props.onUserSelection);
            });
        };
        _this.onSearch = function (options, value) {
            if (value.length <= 2) {
                var filteredOptions = options.filter(function (option) { var _a; return ((_a = option.className) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(value.toLowerCase())); });
                return uniqueBy(filteredOptions, function (fo) { return fo.value; });
            }
            else {
                return uniqueBy(options, function (o) { return o.value; });
            }
        };
        _this.probeSetFamilyHasMIValidatedEntry = function (f) {
            if (_this.props.probeSetState.target.id === f.id) {
                return _this.props.probeSetState.target.miValidated;
            }
            else {
                return false;
            }
        };
        _this.scaleInputsLocked = function () {
            return _this.props.lockScales && _this.effectiveProbePresetScale() !== "";
        };
        _this.effectiveProbePresetScale = function () {
            var _a;
            return (_a = _this.props.probePresetScale) !== null && _a !== void 0 ? _a : "";
        };
        _this.probePmolScaleValue = function () {
            var _a;
            return (_a = _this.props.probeSetState.probeScalePmol) !== null && _a !== void 0 ? _a : "";
        };
        _this.probeHybridizationAScaleValue = function () {
            var _a;
            return (_a = _this.props.probeSetState.probeHybridizationAScale) !== null && _a !== void 0 ? _a : "";
        };
        _this.probeHybridizationBScaleValue = function () {
            var _a;
            return (_a = _this.props.probeSetState.probeHybridizationBScale) !== null && _a !== void 0 ? _a : "";
        };
        _this.probeScaleUlValue = function () {
            var _a;
            return (_a = _this.props.probeSetState.probeScaleUl) !== null && _a !== void 0 ? _a : "";
        };
        _this.parseNonNegativeNumber = function (value) {
            if (value.trim() === "") {
                return 0;
            }
            var parsed = Number(value);
            if (Number.isNaN(parsed) || parsed < 0) {
                return undefined;
            }
            return parsed;
        };
        return _this;
    }
    ProbeSetForm.prototype.render = function () {
        var orgLabel = React.createElement(React.Fragment, null, "Organism");
        var probeSetLabel = React.createElement(React.Fragment, null, "Probe ");
        var scaleLocked = this.scaleInputsLocked();
        var organism = this.props.probeSetState.organism;
        var target = this.props.probeSetState.target;
        return React.createElement(Grid, { stackable: true, relaxed: 'very' },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16, textAlign: 'right' }, this.props.probePresetScale != null
                    ? React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: 'check circle', color: 'green' }),
                        React.createElement("span", { style: { color: 'green' } }, "Preset scale applied"))
                    : React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: 'warning sign', color: 'yellow' }),
                        React.createElement("span", { style: { color: '#b58900' } }, "No preset scale applied")))),
            React.createElement(Grid.Row, { verticalAlign: 'top' },
                React.createElement(Grid.Column, { width: 8 },
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeSet/libraryOrganism/id', errors: this.props.errors, labelContent: orgLabel },
                        React.createElement(Select, { name: 'organism', onBlur: this.props.onUserSelection, onChange: this.onOrganismChange, options: this.effectiveOrganisms(), onAddItem: this.onAddCustomOrganism, additionLabel: 'Custom Organism: ', additionPosition: "bottom", placeholder: 'Type-in or select organism.', allowAdditions: true, selectOnBlur: false, selectOnNavigation: false, search: true, icon: false, value: this.noOrganismSelected() ? "" : organism.id })))),
            React.createElement(Grid.Row, { verticalAlign: 'top' },
                React.createElement(Grid.Column, { width: 5 },
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeSet/customTarget/name', errors: this.props.errors, labelContent: probeSetLabel, labelFor: 'target-custom' },
                        React.createElement(Select, { additionLabel: "Custom Target: ", additionPosition: "bottom", allowAdditions: true, onAddItem: this.onAddCustomTarget, icon: false, clearable: true, disabled: this.noOrganismSelected(), className: 'gene-symbol', loading: this.props.probeSetState.searchLoading, type: 'text', name: 'target-custom', onBlur: this.props.onUserSelection, onChange: this.onTargetChange, onSearchChange: this.onSearchChange, selectOnBlur: false, selectOnNavigation: false, options: this.noOrganismSelected() ? [] : this.effectiveTargets(), placeholder: 'Enter target gene (e.g., tpm3)', search: this.onSearch, spellCheck: false, value: this.noTargetSelected() ? "" : target.id }))),
                React.createElement(Grid.Column, { width: 4 },
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/probeSetComponent/probeSet/target/accession', labelContent: accessionLabel, labelFor: 'accession' },
                        React.createElement(Input, { type: 'text', name: 'accession', onBlur: this.props.onUserSelection, onChange: this.onAccessionChange, value: this.props.probeSetState.target.accession }))),
                React.createElement(Grid.Column, { width: 7 },
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeSet/customTarget/targetMrnaSeq', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                            "RNA target sequence ",
                            target.targetMrnaSeq.length > 0
                                ? "(" + target.targetMrnaSeq.length + " nt) "
                                : '',
                            React.createElement(Help, null, rnaHelp)), labelFor: 'rna-target-seq' },
                        React.createElement(Input, { name: 'rna-target-seq', onBlur: this.props.onUserSelection, onChange: this.onRnaSeqChange, style: { 'fontFamily': 'monospace' }, placeholder: 'Enter target sequence (e.g., CUCGGA...)', value: target.targetMrnaSeq })))),
            this.props.probeSetState.target.targetMrnaSeq.length < 1350
                && this.props.probeSetState.target.targetMrnaSeq.length > 0
                && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 16 },
                        React.createElement(Icon, { name: 'clipboard outline' }),
                        React.createElement("em", null, "When possible, please provide 1350 nt or more (including 5' and 3' UTRs)"))),
            React.createElement(Grid.Row, { verticalAlign: 'top' },
                React.createElement(Grid.Column, { width: 8 },
                    React.createElement(Form.Field, { disabled: this.noOrganismSelected() },
                        React.createElement("label", { htmlFor: 'channel-hcr' }, amplifierLabel),
                        React.createElement(Select, { name: 'amp-hcr', onChange: this.onAmplifierChange, options: this.amplifierOptions(), value: this.props.probeSetState.hcrAmplifier ? this.props.probeSetState.hcrAmplifier.id : undefined }))),
                React.createElement(Grid.Column, { width: 8 }, this.customTargetProbeSetSizeInput())),
            React.createElement(Grid.Row, { verticalAlign: 'top' },
                React.createElement(Grid.Column, { width: 8 },
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/scale/pmolScale', errors: this.props.errors, labelContent: 'Probe Scale (pmol)', labelFor: 'probe-pmol-scale', disabled: scaleLocked },
                        React.createElement(Input, { name: 'probe-pmol-scale', type: 'number', step: 'any', disabled: scaleLocked, onChange: this.onPmolScaleChange, value: this.probePmolScaleValue() }))),
                React.createElement(Grid.Column, { width: 8 },
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeScaleUl', errors: this.props.errors, labelContent: 'Probe Scale (µL)', labelFor: 'probe-scale-ul', disabled: scaleLocked },
                        React.createElement(Input, { name: 'probe-scale-ul', type: 'number', step: 'any', disabled: scaleLocked, onChange: this.onProbeScaleUlChange, value: this.probeScaleUlValue() })))),
            React.createElement(Grid.Row, { verticalAlign: 'top' },
                React.createElement(Grid.Column, { width: 8 },
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeHybridizationAScale/volumeScaleUl', errors: this.props.errors, labelContent: 'Probe Hybridization Buffer A Scale (µL)', labelFor: 'probe-hybridization-a-scale', disabled: scaleLocked },
                        React.createElement(Input, { name: 'probe-hybridization-a-scale', type: 'number', step: 'any', disabled: scaleLocked, onChange: this.onProbeHybridizationAScaleChange, value: this.probeHybridizationAScaleValue() }))),
                React.createElement(Grid.Column, { width: 8 },
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeHybridizationBScale/volumeScaleUl', errors: this.props.errors, labelContent: 'Probe Hybridization Buffer B Scale (µL)', labelFor: 'probe-hybridization-b-scale', disabled: scaleLocked },
                        React.createElement(Input, { name: 'probe-hybridization-b-scale', type: 'number', step: 'any', disabled: scaleLocked, onChange: this.onProbeHybridizationBScaleChange, value: this.probeHybridizationBScaleValue() })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 8, floated: 'right' },
                    React.createElement("div", { className: 'price-column-padded' },
                        React.createElement(PriceDisplay, { loading: this.props.priceLoading, priceCents: this.props.priceCents })))),
            this.props.enableCustomPrice &&
                React.createElement(CustomPriceRow, { customPrice: this.props.probeSetState.customPrice, defaultEffectivePriceCents: this.props.priceCents, disabled: this.props.customPriceLocked, errors: this.props.errors, errorPathPrefix: '/probeSetComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection }));
    };
    return ProbeSetForm;
}(React.PureComponent));
export default ProbeSetForm;
var RnaCishEditableOrganism = /** @class */ (function () {
    function RnaCishEditableOrganism(name, scientificName, id) {
        this.name = name;
        this.id = id;
        this.scientificName = scientificName;
    }
    RnaCishEditableOrganism.prototype.displayName = function () {
        return this.name + " " + (this.scientificName.length > 0 && this.scientificName !== this.name ? '(' + this.scientificName + ')' : '');
    };
    RnaCishEditableOrganism.default = function () {
        return new RnaCishEditableOrganism('', '', -1);
    };
    RnaCishEditableOrganism.fromLibOrg = function (org) {
        return org ? new RnaCishEditableOrganism(org.name, org.scientificName, org.id) : RnaCishEditableOrganism.default();
    };
    return RnaCishEditableOrganism;
}());
export { RnaCishEditableOrganism };
var RnaCishEditableTarget = /** @class */ (function () {
    function RnaCishEditableTarget(name, description, accession, rnaSeq, probeSetSize, id, miValidated, predictedTarget, variantId) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.accession = accession;
        this.targetMrnaSeq = rnaSeq;
        this.probeSetSize = probeSetSize;
        this.miValidated = miValidated;
        this.predictedTarget = predictedTarget;
        this.variantId = variantId;
    }
    // use old-style method syntax so Jest matchers allow equality
    RnaCishEditableTarget.prototype.withAccession = function (a) {
        return new RnaCishEditableTarget(this.name, this.description, a, this.targetMrnaSeq, this.probeSetSize, this.id, this.miValidated, this.predictedTarget, undefined);
    };
    ;
    RnaCishEditableTarget.prototype.withRna = function (r) {
        return new RnaCishEditableTarget(this.name, this.description, "", r, this.probeSetSize, this.id, this.miValidated, this.predictedTarget, undefined);
    };
    ;
    RnaCishEditableTarget.prototype.withProbeDesign = function (variantId) {
        return new RnaCishEditableTarget(this.name, this.description, this.accession, this.targetMrnaSeq, this.probeSetSize, this.id, this.miValidated, this.predictedTarget, variantId);
    };
    ;
    RnaCishEditableTarget.prototype.withProbeSetSize = function (s) {
        return new RnaCishEditableTarget(this.name, this.description, this.accession, this.targetMrnaSeq, s, this.id, this.miValidated, this.predictedTarget, undefined);
    };
    ;
    RnaCishEditableTarget.prototype.displayName = function () {
        return this.name + " " + (this.description.length > 0 ? '(' + this.description + ')' : '');
    };
    RnaCishEditableTarget.default = function (probeSetSize) {
        return new RnaCishEditableTarget('', '', '', '', probeSetSize, -1, false, false, undefined);
    };
    RnaCishEditableTarget.fromLibTarget = function (libVariant) {
        return new RnaCishEditableTarget(libVariant.probeSetFamily.geneSymbol, libVariant.probeSetFamily.description, libVariant.accession
            ? libVariant.accession.transcriptAccession : "", libVariant.targetMrnaSeq, libVariant.probeSetSize, libVariant.probeSetFamily.id, libVariant.validated === ValidationType.MI_VALIDATED, libVariant.accession ? libVariant.accession.accessionType === AccessionType.PREDICTED : false, undefined);
    };
    return RnaCishEditableTarget;
}());
export { RnaCishEditableTarget };
// TODO implement this for cish (use mi validated icons instead of the old positive control icons like this)
export var miValidatedIcon = 'check square outline';
// const miValidatedText = <p> MI Validated probe sets are those marked <Icon name={miValidatedIcon}/>in
//     each of three
//     dropdowns:
//     "Probe set", "For use with channel", "Probe set size".
// </p>;
var accessionLabel = React.createElement(React.Fragment, null,
    "Accession # ",
    React.createElement(Help, null,
        "Enter the accession number for your target RNA. For example, enter \"NM_131875\" for target \"sox10\" in organism ",
        React.createElement("em", null, "Danio rerio"),
        ". Target accession numbers can be found on ",
        React.createElement("a", { href: "https://www.ncbi.nlm.nih.gov/" }, "NCBI"),
        ". For organisms that are not yet on NCBI, probes are designed using private transcriptome databases, there are no accession numbers, and names are non-standard. In this case, be sure to check that the stated RNA target sequence database."));
var rnaHelp = React.createElement(React.Fragment, null,
    "Enter the sequence for your target RNA (only A,C,G,U are all allowed; T will be converted to U) including 5' and 3' UTRs. Please email ",
    React.createElement("a", { href: "mailto:support@molecularinstruments.com" }, "support@molecularinstruments.com"),
    " regarding non-standard target sequences.");
var amplifierLabel = React.createElement(React.Fragment, null,
    "For use with amplifier ",
    React.createElement(Help, null, "Specify the HCR\u2122 Amplifier that you will use with your probes."));
export var rnaCishAccessionsPopup = function (accessions, label) {
    return React.createElement(Popup, { trigger: React.createElement(Button, { icon: 'search plus', label: label, size: 'mini' }), on: 'click' },
        React.createElement(Popup.Header, null, "Accession Numbers"),
        React.createElement(Popup.Content, null,
            React.createElement(Table, { celled: true, collapsing: true, striped: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null, "Accession #"),
                        React.createElement(Table.HeaderCell, null, "Transcript Name"),
                        React.createElement(Table.HeaderCell, null, "Transcript Length"),
                        React.createElement(Table.HeaderCell, null, "Accession Type"))),
                React.createElement(Table.Body, null, accessions.map(function (a) {
                    return React.createElement(Table.Row, { key: a.id },
                        React.createElement(Table.Cell, { title: "Id: " + a.id }, accessionSearchLink(a.transcriptAccession)),
                        React.createElement(Table.Cell, null, a.transcriptName),
                        React.createElement(Table.Cell, null, a.transcriptLength),
                        React.createElement(Table.Cell, null, a.accessionType));
                })))));
};
export var ValidationType;
(function (ValidationType) {
    ValidationType["MI_VALIDATED"] = "MI_VALIDATED";
    ValidationType["VERIFIED_USER"] = "VERIFIED_USER";
    ValidationType["NORMAL_USER"] = "NORMAL_USER";
    ValidationType["NOT_VALIDATED"] = "NOT_VALIDATED";
})(ValidationType || (ValidationType = {}));
export var AccessionType;
(function (AccessionType) {
    AccessionType["PREDICTED"] = "PREDICTED";
    AccessionType["VERIFIED"] = "VERIFIED";
})(AccessionType || (AccessionType = {}));
//# sourceMappingURL=ProbeSetForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/ProbeSetForm.js
// module id = 43
// module chunks = 0